<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> TRANSPORTADORA </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="shipping.id"
          >{{ shipping.id }} -
          {{ shipping.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="shipping.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" xs="12" md="8"> </v-col> -->
            <!-- </v-row> -->
            <!-- <v-row> -->
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="shipping.document"
                class="text-field-uppercase"
                label="CPF/CNPJ"
                v-mask="'99.999.999/9999-99'"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-text-field
                v-model="shipping.state_registration"
                class="text-field-uppercase"
                label="Inscrição Estadual"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="text-h6">Endereço</label>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="shipping.zip_code"
                class="text-field-uppercase"
                label="CEP"
                v-mask="'99.999-999'"
                dense
                outlined
                @blur="handleZipCode()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="shipping.address"
                class="text-field-uppercase"
                label="Logradouro"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="shipping.number"
                class="text-field-uppercase"
                label="Número"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="shipping.complement"
                class="text-field-uppercase"
                label="Complemento"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="shipping.neighborhood"
                class="text-field-uppercase"
                label="Bairro"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="shipping.city"
                class="text-field-uppercase"
                label="Cidade"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select
                :items="ufs"
                v-model="shipping.state"
                label="UF"
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="shipping.telephone"
                class="text-field-uppercase"
                label="Telefone"
                v-mask="'(99) 99999-9999'"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-text-field
                v-model="shipping.plate"
                class="text-field-uppercase"
                label="Placa"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-select
                :items="ufs"
                v-model="shipping.plate_state"
                label="UF Placa"
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-text-field
                v-model="shipping.email"
                class="text-field-lowercase"
                label="Email 1"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-text-field
                v-model="shipping.email2"
                class="text-field-lowercase"
                label="Email 2"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="shipping.status"
                :label="`Status: ${getLabelStatus(shipping.status)}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/ShippingCompanyRequest";
import { getByZipCode } from "@/api/requests/ZipCodeRequest";

import { UF_LIST } from "@/api/constants";
import AwesomeMask from "awesome-mask";

export default {
  components: {},
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    loading: false,
    shipping: {
      id: "",
      name: "",
      status: 1,
      address: "",
      number: "",
      neighborhood: "",
      complement: "",
      city: "",
      state: "",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    ufs: [],
  }),
  computed: {},
  created() {
    this.ufs = UF_LIST;
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getMaterial(this.$route.params.id);
      }
    },
    async getMaterial(id) {
      this.loading = true;
      try {
        let response = await API.getById(id);
        this.shipping = response;
      } catch (error) {
        this.shipping = {};
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "Shipping" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        let keys = Object.keys(this.shipping);
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          if (
            typeof this.shipping[key] == "string" &&
            key !== "email" &&
            key !== "email2"
          ) {
            this.shipping[key] = this.shipping[key].toUpperCase();
          }
        }

        this.shipping.status = this.shipping.status ? 1 : 0;
        let data = { ...this.shipping };
        if (this.shipping.id === "") {
          this.post(data);
        } else {
          this.update(this.shipping.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        let res = await API.post(data);
        console.log(res);
        this.goToBackList();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        let res = await API.update(id, data);
        console.log(res);
        this.goToBackList();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    async handleZipCode() {
      if (this.shipping.zip_code !== "") {
        const value = this.shipping.zip_code.replace(".", "").replace("-", "");
        try {
          let res = await getByZipCode(value);
          console.log(res);
          this.shipping.address = res.logradouro;
          this.shipping.number = "";
          this.shipping.neighborhood = res.bairro;
          this.shipping.complement = "";
          this.shipping.city = res.localidade;
          this.shipping.state = res.uf;
        } catch (error) {
          console.log(error);
          this.shipping.address = "";
          this.shipping.number = "";
          this.shipping.neighborhood = "";
          this.shipping.complement = "";
          this.shipping.city = "";
          this.shipping.state = "";
        }
      }
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
.text-field-lowercase input {
  text-transform: lowercase;
}
</style>
